import rawPlaces from "../../data/places.json";
import type { Place } from "./types";

export const seedPlaces = rawPlaces as Place[];
